import React from "react";

const Washing_27 = React.forwardRef(
  ({ width = "41", height = "32", viewBox = "0 0 41 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M34 2H6V6.8447L10.1086 9.20394C12.2723 6.0607 15.8955 4 20 4C24.1653 4 27.835 6.12222 29.9866 9.34437L34 7.04744V2ZM36 5.9028V0H4V5.69625L1.04602 4L0.016932 5.72152L4 8.0087V24.2171L0 26.5064L1.02583 28.2295L4 26.5274V32H36V26.3839L39.2592 28.2554L40.2883 26.5339L36 24.0714V8.21306L40.3054 5.74901L39.2795 4.02586L36 5.9028ZM34 9.3577L30.9569 11.0993C31.6272 12.5956 32 14.2543 32 16C32 17.8307 31.59 19.5657 30.8569 21.1181L34 22.923V9.3577ZM34 25.2354L29.8517 22.8534C27.6835 25.9643 24.0795 28 20 28C15.969 28 12.4023 26.0125 10.2263 22.9639L6 25.3827V30H34V25.2354ZM6 23.0725L9.20155 21.2401C8.43179 19.6568 8 17.8788 8 16C8 14.194 8.39894 12.4813 9.1135 10.945L6 9.15715V23.0725ZM10.856 11.9456C10.3058 13.1848 10 14.5567 10 16C10 17.5172 10.3379 18.9555 10.9425 20.2437L18.1367 16.1263L10.856 11.9456ZM11.9727 21.9644C13.7954 24.4135 16.7124 26 20 26C23.3373 26 26.2927 24.3652 28.1092 21.8528L20.1517 17.2834L11.9727 21.9644ZM29.1154 20.1181C29.6836 18.8623 30 17.4681 30 16C30 14.6159 29.7188 13.2976 29.2105 12.0989L22.1686 16.1291L29.1154 20.1181ZM28.2457 10.3408C26.4429 7.71906 23.4222 6 20 6C16.6377 6 13.6629 7.65941 11.8501 10.2039L20.1536 14.972L28.2457 10.3408Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_27;
